import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import React from 'react';
import { Link } from 'react-router-dom';
import { AuthData, withAuthContext } from '../context/auth';
import { RenewalResponse } from '../types/renewals';
import { tableStyles } from '../util/styles';
import { getComparator, HeadCell, Order, stableSort } from '../util/tableUtil';
import { capitalize } from '../util/util';
import { StyledEmptyMessage } from './common/index';
import SortableTable from './SortableTable';

interface Props {
	renewals: RenewalResponse[];
	authData: AuthData;
}

interface Data {
	renewalId: string;
	dateCreated: string;
	endDate: string;
	status: string;
	link: string;
}

function createData(
	renewalId: string,
	dateCreated: string,
	endDate: string,
	status: string,
	link: string,
): Data {
	return { renewalId, dateCreated, endDate, status, link };
}

const RenewalsTable = (props: Props) => {
	const { renewals, authData } = props;
	const [order, setOrder] = React.useState<Order>('asc');
	const [orderBy, setOrderBy] = React.useState<string>('renewalId');

	const emptyTable = !renewals.length ? (
		<StyledEmptyMessage>No Renewals</StyledEmptyMessage>
	) : null;
	const classes = tableStyles();

	const headCells: HeadCell[] = [
		{ id: 'renewalId', rightAlign: false, label: 'Renewal ID' },
		{ id: 'dateCreated', rightAlign: false, label: 'Date Created' },
		{ id: 'endDate', rightAlign: false, label: 'New Policy End Date' },
		{ id: 'status', rightAlign: false, label: 'Current Status' },
	];

	const rows: any = renewals.map((renewal: any, index: number) => {
		const defaultUrl =
			renewal.state === 'application' ? `policyDetails` : `price-breakdown`;

		return createData(
			renewal.locator,
			renewal.createdTimestamp,
			renewal.renewalEndTimestamp.toString(),
			capitalize(renewal.state),
			`${renewal.locator}/${defaultUrl}`,
		);
	});

	const rowElements = stableSort(rows, getComparator(order, orderBy)).map(
		(row: any, index: number) => {
			return (
				<TableRow
					hover
					tabIndex={-1}
					key={row.renewalId}
					component={Link}
					to={row.link}
					className={classes.tableRow}
				>
					<TableCell scope='row'>{row.renewalId}</TableCell>
					<TableCell>{authData.getFormattedDate(row.dateCreated)}</TableCell>
					<TableCell>{authData.getFormattedDate(row.endDate)}</TableCell>
					<TableCell>{row.status}</TableCell>
				</TableRow>
			);
		},
	);

	return (
		<SortableTable
			rows={rowElements}
			headCells={headCells}
			additionalMsg={emptyTable}
			order={order}
			setOrder={setOrder}
			orderBy={orderBy}
			setOrderBy={setOrderBy}
		/>
	);
};

export default withAuthContext<Props>(RenewalsTable);
